module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG697eda4258e5577b574e3db6de7fc8a9.697eda42.png";